import apiV2 from '../api/v2';
import { toDmError } from './dmErrors';

export interface DmEventItem {
    eventId: number;
    creationDate: string;
    type: string;
    level: string;
    actionRequired: boolean;
    isResolved: boolean;
    title: string;
    notificationComments: Array<{ title: string }>;
}

export interface DmEventsPage {
    items: DmEventItem[];
    cursor: { before: string | null; after: string | null };
}

export async function fetchDmEvents(
    patientId: string,
    limit = 20,
    cursor?: string
): Promise<DmEventsPage> {
    const params: Record<string, string | number> = { limit };
    if (cursor) params.cursor = cursor;

    try {
        const response = await apiV2.get<{ success: boolean; data: DmEventsPage }>(
            `/patients/${patientId}/monitoring/events`,
            { params }
        );
        return response.data.data;
    } catch (err) {
        throw toDmError(err);
    }
}
